import { Injectable } from "@angular/core";

import { QueryStringSerializationService } from "../../../../shared-library/services/environment/query-string-serialization.service";

import { SearchTabAlias } from "../../../enums/search-tab-alias.enum";

import { MarketplaceSearchParametersModel } from "../models/marketplace-search-parameters.model";
import { SearchTabConfigModel } from "../models/search-tab-config.model";

@Injectable({
    providedIn: "root"
})
export class MarketplaceSearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string, searchTabConfig: SearchTabConfigModel): MarketplaceSearchParametersModel {
        const rawValues = this._serializationService.deserialize<MarketplaceSearchParametersModel>(queryString);
        const parsedValues = new MarketplaceSearchParametersModel();

        parsedValues.searchTab = searchTabConfig.tabAlias;
        parsedValues.searchText = (rawValues.searchText || "").replace(/(\+)+/gi, " ").trim();

        if (rawValues.searchTab === SearchTabAlias.MARKETPLACE_SEARCH) {
            parsedValues.sortOption = rawValues.sortOption || "Rank;asc";
            parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
            parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 10;

            if (parsedValues.sortOption.split(";").length !== 2) {
                parsedValues.sortOption = "Rank;asc";
            }

            parsedValues.categories = rawValues.categories || [];
            parsedValues.areas = rawValues.areas || [];
            parsedValues.minPrice = rawValues.minPrice || "0";
            parsedValues.maxPrice = rawValues.maxPrice || "";
        } else {
            parsedValues.sortOption = "Rank;asc";
            parsedValues.pageNumber = 1;
            parsedValues.pageSize = 10;

            parsedValues.categories = [];
            parsedValues.areas = [];
            parsedValues.minPrice = "0";
            parsedValues.maxPrice = "";
        }

        return parsedValues;
    }

    public serialiseToQueryString(searchParams: MarketplaceSearchParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
